export const ROLE_TAG_COLOR = {
	OPERATOR: 'success',
	BASIC: 'blue',
	OPERATORPLUS: 'orange',
};
